import { render, staticRenderFns } from "./Indexqueue.vue?vue&type=template&id=2bb87036&scoped=true&"
import script from "./Indexqueue.vue?vue&type=script&lang=js&"
export * from "./Indexqueue.vue?vue&type=script&lang=js&"
import style0 from "./Indexqueue.vue?vue&type=style&index=0&id=2bb87036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb87036",
  null
  
)

export default component.exports